import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import ENTITLEMENTS_ORGANIZATION_QUERY, {
	type EntitlementsEntitlementsQuery,
} from '@atlassian/jira-relay/src/__generated__/EntitlementsEntitlementsQuery.graphql';

const getCustomerServiceOrganizationAri = (
	organizationId: string,
	activationId: string,
): string => {
	return `ari:cloud:jira-servicedesk::organization/activation/${activationId}/${organizationId}`;
};

export const EntitlementsEntitlementsQueryResource =
	createRelayResource<EntitlementsEntitlementsQuery>({
		type: 'ENTITLEMENTS_ORGANIZATION_QUERY',
		getQuery: ({ match }, { tenantContext }) => ({
			parameters: ENTITLEMENTS_ORGANIZATION_QUERY,
			variables: {
				organizationId: getCustomerServiceOrganizationAri(
					String(match.params.organizationId),
					tenantContext.activationId,
				),
				cloudId: tenantContext.cloudId,
			},
			options: { fetchPolicy: 'store-and-network' },
		}),
	});
